<template>
    <div id="app">
        <container-loader style="margin: auto"  v-if="!isUserDataLoaded"></container-loader>

        <div v-else>
            <test-pop-u-p ref="customPopUp"></test-pop-u-p>
            <section>
                <nav-bar></nav-bar>

        <div class="container-custom">
          <router-view/>


        </div>
      </section>

      <div>
        <editor3-d></editor3-d>
      </div>



      <Footer></Footer>
    </div>

    <b-modal ref="printFilePopup" v-model="openPrintFile" title="Print file" modal-class="modal--clear" size="xl"
             hide-footer>
      <choose-printer-for-action :file-id="printFileId" modal-class="modal--clear" :printer-type="printFilePrinterType" action="print"
                                 @close="handleClosePrintFile"></choose-printer-for-action>
    </b-modal>

        <svg width="0" height="0" class="hidden">
                <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="trash">
                    <path d="M15 4c-.523 0-1.059.184-1.438.563C13.184 4.94 13 5.476 13 6v1H7v2h1v16c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V9h1V7h-6V6c0-.523-.184-1.059-.563-1.438C20.06 4.184 19.523 4 19 4zm0 2h4v1h-4zm-5 3h14v16c0 .555-.445 1-1 1H11c-.555 0-1-.445-1-1zm2 3v11h2V12zm4 0v11h2V12zm4 0v11h2V12z"></path>
                </symbol>

      <symbol aria-hidden="true" data-prefix="fab" data-icon="raspberry-pi" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 407 512" id="raspberry-pi">
        <path fill="currentColor"
              d="M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"></path>
      </symbol>
      <symbol aria-hidden="true" data-prefix="fas" data-icon="video" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512" id="video">
        <path fill="currentColor"
              d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"></path>
      </symbol>
      <symbol aria-hidden="true" data-icon="trash" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="trash">
        <path d="M 15 4 C 14.476563 4 13.941406 4.183594 13.5625 4.5625 C 13.183594 4.941406 13 5.476563 13 6 L 13 7 L 7 7 L 7 9 L 8 9 L 8 25 C 8 26.644531 9.355469 28 11 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 9 L 27 9 L 27 7 L 21 7 L 21 6 C 21 5.476563 20.816406 4.941406 20.4375 4.5625 C 20.058594 4.183594 19.523438 4 19 4 Z M 15 6 L 19 6 L 19 7 L 15 7 Z M 10 9 L 24 9 L 24 25 C 24 25.554688 23.554688 26 23 26 L 11 26 C 10.445313 26 10 25.554688 10 25 Z M 12 12 L 12 23 L 14 23 L 14 12 Z M 16 12 L 16 23 L 18 23 L 18 12 Z M 20 12 L 20 23 L 22 23 L 22 12 Z"/>
      </symbol>
      <symbol aria-hidden="true" data-icon="info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" id="info-icon">
        <g transform="translate(1067.348 -902.9)"><circle cx="11" cy="11" r="11" transform="translate(-1067.348 902.9)" fill="#2cb895"/><path d="M1.713-16.292a1.621,1.621,0,0,1,.481-1.186,1.588,1.588,0,0,1,1.173-.485,1.6,1.6,0,0,1,1.177.49,1.618,1.618,0,0,1,.485,1.182,1.6,1.6,0,0,1-.485,1.177,1.6,1.6,0,0,1-1.177.485,1.6,1.6,0,0,1-1.177-.476A1.61,1.61,0,0,1,1.713-16.292Zm3.72,8.564a1.024,1.024,0,0,0,.166.7,1.024,1.024,0,0,0,.7.166H6.61v1.618H.571V-6.866H.94a1.024,1.024,0,0,0,.7-.166,1.024,1.024,0,0,0,.166-.7v-3.72a1.023,1.023,0,0,0-.166-.7,1.046,1.046,0,0,0-.7-.162H.571v-1.627H5.433Z" transform="translate(-1060.166 924.571)" fill="#fff"/></g>
      </symbol>

    </svg>

    <slicer3 :file-id="slicer3FileId" :printer-type-id="slicer3PrinterTypeId" :show="slicer3Show" static-modal
             @hide="slicer3Show=false"/>

    <quick-print :show="quickPrintShow" @hide="quickPrintShow = false" :file-id="quickPrintFileId"></quick-print>

        <first-login v-if="firstLogin"></first-login>

    <warning-boxes />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import EventBus from "./event/event-bus";
  import Footer from '@/components/Footer.vue';
  import NavBar from '@/components/NavBar.vue';
  import TestPopUP from '@/components/TestPopUP.vue';
  import ContainerLoader from '@/components/ContainerLoader.vue';

    import Editor3D from '@/components/apps/editor3d/Editoe3d.vue'
    import ChoosePrinterForAction from "./components/printers/modal/ChoosePrinterForAction";
    import Slicer3 from "./components/apps/slicer3/Slicer3";
    import QuickPrint from "./components/apps/quickPrint/QuickPrint";
    import WarningBoxes from "@/components/warningbox/WarningBoxes";

  import ApplicationMixin from "./mixins/application";
  import PrinterTypeMixin from "./mixins/printerType";
  import LocalStorage from "./libs/LocalStorage";

  import {SLICER3} from "./libs/SlicerType";
  import FirstLogin from '@/components/account/FirstLogin'
  // import md5 from 'md5';

    export default {
        name: "App",
        components: {
            QuickPrint,
            Slicer3,
            ChoosePrinterForAction,
            Footer,
            NavBar,
            TestPopUP,
            ContainerLoader,
            Editor3D,
            FirstLogin,
            WarningBoxes
        },
        mixins: [ApplicationMixin, PrinterTypeMixin],
        data() {
            return {
                firstLogin: false,
                color:{
                  primary: '#289be8',
                  secondary: '#5AC557',
                  white: '#ffffff'
                },
                openPrintFile: false,
                printFileId: null,
                printFilePrinterType: null,
                slicer3FileId: null,
                slicer3PrinterTypeId: null,
                slicer3Show: false,
                quickPrintShow: false,
                quickPrintFileId: ''
            }
        },
        created() {


      if(LocalStorage.hasValue(LocalStorage.COLOR_KEY)){

        let color = LocalStorage.getValue(LocalStorage.COLOR_KEY, true, {});

        for (const [key, value] of Object.entries(color)) {
          console.log(`${key}: ${value}`);
          document.documentElement.style
            .setProperty(`--${key}`, `${value}`);
        }
      }

      //TODO: ONLY FOR TESTS. REMOVE IT!!!
      if (this.$route.query.lang) {
        this.$locale.change(this.$route.query.lang)
      }
//
    //      console.log(this.$route.params.firstLogin)



      // setInterval(()=>{
      //   //console.log(1);
      //   window.$('.btn--primary').css('backgroundColor', '#007bff')
      //   window.$('.btn--secondary').css('backgroundColor', '#28a745')
      // }, 1)



      //
      // document.addEventListener('click', function(event) {
      //   let specifiedElement = document.getElementById('customdropzone');
      //   console.log(specifiedElement)
      //   if(specifiedElement){
      //     let isClickInside = specifiedElement.contains(event.target);
      //
      //     if (!isClickInside) {
      //       alert(1)
      //     }
      //   }
      // });

      window.lan = (lan) =>{
        this.$locale.change(lan)
      }


      if (!this.isUserDataLoaded) {
        this.fetchUserData();
      }

      window.addEventListener('message', (ev) => {
        if (ev.data === 'closeIframe') {
          this.closeSlicer3()
        }

        if (ev.data === 'closeIframe_simple') {
          this.closeSlicer3();
        }

        if (ev.data && typeof ev.data === 'string' && ev.data.indexOf('slice_slicer3') >= 0) {
          const slicer3Data = ev.data.split('|');
          if (slicer3Data.length > 1) {
            this.saveSlicerTypeByFile(slicer3Data[1], SLICER3);
          }
          if (slicer3Data.length > 2) {
            this.saveSlicerTypeByPrinterType(slicer3Data[2], SLICER3);
          }
        }

        if (ev.data === 'closeIframe_and_projects') {
          this.closeSlicer3();
        }

        if (typeof ev.data.indexOf == 'function' && ev.data.indexOf('closeIframe_and_toolpath|') != -1) {
          this.closeSlicer3();
          let fileId = ev.data.substring(ev.data.indexOf('|') + 1);
          this.oldApps_showToolpathViewer(fileId, '');
        }

        if (typeof ev.data.indexOf == 'function' && ev.data.indexOf('closeIframe_and_stleditor|') != -1) {
          this.closeSlicer3();
          let fileId = ev.data.substring(ev.data.indexOf('|') + 1);
          this.oldApps_showStlEditor(fileId, '');

        }
      });

      //Listen printer log of no space available on printer
      EventBus.$on('printer_log:no_space', (data) => {
        //Get printer data
        const printerIndex = this.getPrinterIndex(data.printerId);
        if (printerIndex < 0) {
          return;
        }
        const printer = this.getPrinters[printerIndex];
        //Get job data
        const jobIndex = this.getJobIndex(data.jobId);
        if (jobIndex < 0) {
          return;
        }
        const job = this.getJobs[jobIndex];
        //Show notification
        this.msgBoxOk(this.$t('notification.printerNoSpace', {printerName: printer.printer_name, jobName: job.filename}));
      });

    },
    mounted() {
      window.vuePrintFile = this.printFile;
      window.vueOpenSlicer3 = this.openSlicer3;
      window.vueOpenQuickPrint = this.openQuickPrint;
      window.vueGetLastUsedPrinterTypeId = this.getLastUsedPrinterTypeId;
      window.vueGetPrimaryPrinterTypeId = this.getPrimaryPrinterTypeId;
      window.vueGetUserActivePrinterTypes = this.getUserActivePrinterTypes;
      window.vueSaveSlicerTypeByFile = this.saveSlicerTypeByFile;
      window.vueSaveSlicerTypeByPrinterType = this.saveSlicerTypeByPrinterType;
      window.isPrinterTypeSupportedBySlicer3 = this.isPrinterTypeSupportedBySlicer3;
      window.isPrinterTypeMakerbot5thGen = this.isPrinterTypeMakerbot5thGen;
      if (this.$route.query.first_login === 'yes') {
        //console.log(this.$route.query)
        this.firstLogin = true
      }

          // setTimeout(()=>{
          //   // this.$intercom.boot({
          //   //   user_id: md5(this.userData.email),
          //   //   name: this.userData.lastname + ' ' + this.userData.firstname,
          //   //   email: this.userData.email,
          //   // });
          //
          //
          //   this.$analytics.fbq.init('717367561710504', {
          //     email: this.userData.email,
          //   })
          //
          // }, 2000)


    },
    computed: {
      ...mapGetters(['isUserDataLoaded', 'userData', 'isPrinterTypeSupportedBySlicer3', 'isPrinterTypeMakerbot5thGen'])
    },
    methods: {
      ...mapActions(['fetchUserData', 'saveSlicerTypeByFile', 'saveSlicerTypeByPrinterType', 'getPrinterIndex', 'getPrinters', 'getJobIndex', 'getJobs']),

      handleClosePrintFile() {
        this.openPrintFile = false;
      },
      closeSlicer3() {
        this.slicer3Show = false;
        if (this.$route.name !== 'Projects') {
          this.$router.push('/projects')
        }
      },
      printFile(fileId, printerType) {
        this.printFileId = fileId;
        this.printFilePrinterType = printerType;
        this.openPrintFile = true;
      },
      openSlicer3(fileId, printerTypeId) {
        this.slicer3FileId = fileId;
        this.slicer3PrinterTypeId = printerTypeId !== undefined ? printerTypeId : null;
        this.slicer3Show = true;
      },
      openQuickPrint(fileId) {
        this.quickPrintFileId = fileId;
        this.quickPrintShow = true;
      }
    }
  }
</script>
<style lang="scss">

  @import "scss/theme";

  a.active.focus,
  a.active:focus,
  a.focus,
  a:active.focus,
  a:active:focus,
  a:focus,
  button.active.focus,
  button.active:focus,
  button.focus,
  button:active.focus,
  button:active:focus,
  button:focus,
  .btn.active.focus,
  .btn.active:focus,
  .btn.focus,
  .btn:active.focus,
  .btn:active:focus,
  .btn:focus {
      outline: 0!important;
      outline-color: transparent!important;
      outline-width: 0!important;
      outline-style: none!important;
      box-shadow: 0 0 0 0 rgba(0,123,255,0)!important;
  }
  .dropdown-toggle.no--arr::after {
    display: none;
  }

  #app {
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 100vh;
    }
  }




</style>
